// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1UXWu","log":"ModalInventoryLogs_log__4J87E","date":"ModalInventoryLogs_date__2ZlbZ","userName":"ModalInventoryLogs_userName__2-zEo"};